import { render, staticRenderFns } from "./CommentAndConclusion.vue?vue&type=template&id=6c6cadac&scoped=true"
import script from "./CommentAndConclusion.vue?vue&type=script&lang=js"
export * from "./CommentAndConclusion.vue?vue&type=script&lang=js"
import style0 from "./CommentAndConclusion.vue?vue&type=style&index=0&id=6c6cadac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cadac",
  null
  
)

export default component.exports